import { countMessagesSentByQuarterHourOfWeek } from '../queries/countMessagesSentByQuarterHourOfWeek'

export const messagesSentByQuarterHourOfWeekGauge = {
  id: 'messagesSentByQuarterHourOfWeekGauge',
  queries: [countMessagesSentByQuarterHourOfWeek],
  title: 'Busiest Hours of The Day',
}
